import { render, staticRenderFns } from "./FirstLogin.vue?vue&type=template&id=36ac5542"
import script from "./FirstLogin.vue?vue&type=script&lang=js"
export * from "./FirstLogin.vue?vue&type=script&lang=js"
import style0 from "./FirstLogin.vue?vue&type=style&index=0&id=36ac5542&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports